import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad9792c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "authorized-store" }
const _hoisted_2 = { class: "flex-bwn-ter authorized-store-head" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "flex-center" }
const _hoisted_5 = { style: {"margin-right":"6px"} }
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode("0")
const _hoisted_8 = {
  class: "flex-cen-ter",
  style: {"height":"50px"}
}
const _hoisted_9 = { class: "tooltip-wrap" }
const _hoisted_10 = { class: "header flex -bwn" }
const _hoisted_11 = { class: "title" }
const _hoisted_12 = { class: "content mt_5" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  class: "flex-cen-ter",
  style: {"height":"50px"}
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }

import { t } from '@/plugins/i18n'
import { ref, computed, nextTick, onMounted, getCurrentInstance } from 'vue'
import STable from '@/components/Table/index.vue'
import CreateShop from '@/components/common/CreateShop.vue'
import SignupPanel from '@/views/signup/components/SignupPanel.vue'
// import SignupForm from '@/components/Signup/form.vue'
import AppLink from '@/components/common/AppLink.vue'
import CancelVisible from './CancelVisible.vue'
import { storeColumns, tableConfig, b2bEditableTabs } from './data'
import useTabData from '@/util/useTabData'
import { useRtfix, isD2C, useSite2Station, isJA, isKO, isEN, useSite } from '@/store'
import { Edit, Warning, CircleClose } from '@element-plus/icons-vue'
import { shopList, autoOrder } from '@/apis/user'
import Guide from '@/components/guide/index.vue'
import { ElMessage } from 'element-plus'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import ConfirmOrder from '@/views/usercenter/Order/SyncOrder/ConfirmOrder.vue'
import SyncOrderLimit from './SyncOrderLimit.vue'
import AuthShopChange from './AuthShopChange.vue'
import memberEventBox from '@/components/common/MemberEventBox.vue'
import { confirmApiUnbind } from '@/util/useConfirm'
import { Site } from '@/common/const'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const store = useStore()
// 店铺信息
const curshop = computed(() => store.getters?.shopInfo)

if (!route?.query?.customerShopPlatform) {
  setTimeout(() => {
    confirmApiUnbind(true)
  }, 1000)
}

const site = useSite()
// 根据平台过滤Base店铺
const filterShoppData = () => {
  // 2023-7-13：如果不是日本站过滤Base店铺。无论是否日本过滤Shopify
  return store.state.bussiness.Shops.filter((e: any) =>
    !e.site || (e.site.includes(site) && e.source === 'd2c')
  )
}

const isSub = store.getters.isSub
const membership = store.getters.membership
const editableTabs = isD2C() ? filterShoppData() : b2bEditableTabs
const STableRef = ref()
const refreshTable = (type?: boolean) => {
  if (type) {
    pageData.value = {
      page: 1,
      limit: 30
    }
  }
  nextTick(() => {
    STableRef.value && STableRef.value.getData()
  })
}

const pageData = ref({
  page: 1,
  limit: 30
})

const tabKey = isD2C() ? 'customerShopPlatform' : 'shopAuthStatus'
const { tabData, [tabKey]: tab } = useTabData({ TabName: tabKey }, () => refreshTable(true))
const filterData = computed(() => {
  return isD2C() ? { customerShopPlatform: tab.value } : { shopAuthStatus: tab.value }
})

const shopVisible = ref(false)
const shopData = ref()
const popverIndex = ref(0)
const { proxy } = getCurrentInstance() as any

// 在店铺列表编辑店铺
const openShopVisible = (row?: any) => {
  // 未授权是有店铺信息的、修改也是有店铺信息
  if (membership.templateLevel === 0 && row) { // 非会员
    STableRef.value.tableData.forEach((item: any) => {
      if (proxy.$refs[`memberPopver${item.customerShopId}`]) {
        proxy.$refs[`memberPopver${item.customerShopId}`].open = false
      }
    })
    proxy.$refs[`memberPopver${row.customerShopId}`].open = true // 非会员显示 || 过期会员
    popverIndex.value = row.customerShopId
  } else {
    shopVisible.value = true
    row && (shopData.value = row)
  }
}
const closePopver = () => {
  proxy.$refs[`memberPopver${popverIndex.value}`].open = false // 关闭tips
}
const shopListen = () => {
  const fn = (data: any) => {
    if (data) {
      if (data === 'true') {
        ElMessage.success(t('店铺授权成功'))
      }
      shopClose()
      clearInterval(timer)
      delete localStorage.__reload__
    }
  }
  const timer = setInterval(() => {
    fn(localStorage.__reload__)
  }, 300)
  //
  setTimeout(() => {
    clearInterval(timer)
  }, 10 * 60 * 1000)
}

const shopClose = () => {
  // emit shopdata.value
  shopVisible.value = false
  shopData.value = null
  store.dispatch('route/updateUser')
  refreshTable()
}

const selectCustomerShopId = ref()
const subAccountVisible = ref(false)
const openSubAccountVisible = (id: any) => {
  subAccountVisible.value = true
  selectCustomerShopId.value = id
  setTimeout(() => {
    if (document.body.clientHeight <= 600) {
      const subAccountDialog: any = document.getElementsByClassName('el-dialog subAccountVisible')[0]
      subAccountDialog.style.scale = '0.9'
      subAccountDialog.style.marginTop = '0'
    }
  }, 100)
}

const rowItem = ref()
const cancelAuthorizedVisible = ref(false)
const openCancelAuthorizedVisible = (row: any) => {
  cancelAuthorizedVisible.value = true
  rowItem.value = row
}

const signupSuccess = () => {
  subAccountVisible.value = false
  ElMessage.success(t('创建成功'))
  refreshTable()
}

const createSuccess = () => {
  ElMessage.success(t('店铺修改成功'))
  store.dispatch('route/updateUser')
  refreshTable()
}

const handleSwitch = (val: any) => {
  val.loading = true
  autoOrder({ customerShopId: val.customerShopId }).then(res => {
    if (res.success) {
      if (val.customerShopAutoOrderFlag) {
        ElMessage.success(t('自動発注をOFFにしました。'))
      } else {
        ElMessage.success(t('自動発注をONにしました。'))
      }
      refreshTable()
    }
  }).finally(() => { val.loading = false })
}

const router = useRouter()
const toStoreFund = async (row: any) => {
  await store.dispatch('route/changeShop', row.customerShopId)
  router.push(useRtfix('StoreFund'))
}

const syncOrderLimit = ref()
const confirmOrderModal = ref()
const splitRemindFlag = computed(() => store.state.route.user.splitRemindFlag)

const confirmSuccess = () => {
  fn()
  fn = null
}
let fn: any = null
const beforeChangeFn = (v: any) => {
  if (membership.templateLevel === 0) { // 过期会员-显示提醒
    syncOrderLimit.value.open()
  } else {
    if (splitRemindFlag.value === 0 && !v.customerShopAutoOrderFlag) {
      confirmOrderModal.value.open()
      fn = () => handleSwitch(v)
      return false
    } else {
      return true
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_table_button = _resolveComponent("table-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('授权店铺管理')), 1),
      (!_unref(isSub))
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (openShopVisible()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('添加新店铺')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (!_unref(isSub))
      ? (_openBlock(), _createBlock(_component_el_tabs, {
          key: 0,
          modelValue: _unref(tabData),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(tabData) ? (tabData).value = $event : null)),
          type: "card",
          class: "demo-tabs"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: _unref(t)('全部'),
              name: "all"
            }, null, 8, ["label"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(editableTabs), (item) => {
              return (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: String(item.value),
                label: _unref(t)(item.label),
                name: String(item.value)
              }, null, 8, ["label", "name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(STable, {
      ref: (_value, _refs) => {
        _refs['STableRef'] = _value
        STableRef.value = _value
      },
      "page-data": pageData.value,
      "onUpdate:page-data": _cache[2] || (_cache[2] = ($event: any) => ((pageData).value = $event)),
      api: _unref(shopList),
      columns: _unref(storeColumns),
      filterData: _unref(filterData),
      tableConfig: _unref(tableConfig)
    }, {
      customerShopName: _withCtx(({ row }) => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(row.customerShopName), 1),
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: ($event: any) => (openShopVisible(row))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Edit))
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      customerShopUrl: _withCtx(({ row }) => [
        _createElementVNode("a", {
          href: row.customerShopUrl,
          target: "_blank"
        }, _toDisplayString(row.customerShopUrl), 9, _hoisted_6)
      ]),
      availableAmount: _withCtx(({ row }) => [
        _createVNode(_component_el_button, {
          type: "text",
          onClick: ($event: any) => (toStoreFund(row))
        }, {
          default: _withCtx(() => [
            (row.availableAmount)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(row.availableAmount) + " " + _toDisplayString(_unref(t)('元')) + " > ", 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_7
                ], 64))
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      customerShopAuthStatusHead: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(memberEventBox, { icon: "member_header" }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_unref(t)('API状态')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      customerShopAuthStatus: _withCtx(({ row }) => [
        (row.customerShopAuthStatus === 0)
          ? (_openBlock(), _createBlock(_component_el_tooltip, {
              key: 0,
              visible: false,
              effect: "light",
              ref: `memberPopver${row.customerShopId}`
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_icon, {
                        color: "#E6A23C",
                        class: "icon-style",
                        size: "14px"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Warning))
                        ]),
                        _: 1
                      }),
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('提示')), 1)
                    ]),
                    _createVNode(_component_el_icon, {
                      onClick: closePopver,
                      color: "#F56C6C",
                      size: "14px",
                      style: {"cursor":"pointer"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(CircleClose))
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    (_unref(isSub))
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 0,
                          innerHTML: _unref(t)('尊敬的用户，您需办理会员后，方可授权绑定子店铺，请联系主账号办理').replace('请联系主账号办理', `<b>请联系主账号办理</b>`)
                        }, null, 8, _hoisted_13))
                      : (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_unref(t)('尊敬的用户，您需办理会员成功后，方可授权绑定子店铺')), 1))
                  ]),
                  _createVNode(_component_router_link, {
                    to: _unref(useRtfix)('VipLevel')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, { class: "btn mt_5" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('办理会员')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["to"])
                ])
              ]),
              default: _withCtx(() => [
                (!(_unref(tabData) == 7 || _unref(tabData) == 0))
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "customerShopPlatform",
                      onClick: ($event: any) => (openShopVisible(row))
                    }, _toDisplayString(_unref(t)('未授权')) + " >", 9, _hoisted_15))
                  : (_openBlock(), _createElementBlock("span", _hoisted_16, "-"))
              ]),
              _: 2
            }, 1536))
          : (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_unref(membership).templateLevel === 0 ? _unref(t)('已授权（禁用）') : _unref(t)('已授权')), 1))
      ]),
      activeSubAccountFlagHead: _withCtx(() => [
        _createElementVNode("div", _hoisted_18, [
          _createVNode(memberEventBox, { icon: "member_header" }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_unref(t)('店铺账号')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      activeSubAccountFlag: _withCtx(({ row }) => [
        (!row.activeSubAccountFlag)
          ? (_openBlock(), _createBlock(memberEventBox, {
              key: 0,
              subscript: false,
              "listen-variable": row
            }, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  onClick: ($event: any) => (openSubAccountVisible(row.customerShopId))
                }, _toDisplayString(_unref(t)('激活子账号')), 9, _hoisted_19)
              ]),
              _: 2
            }, 1032, ["listen-variable"]))
          : (_openBlock(), _createElementBlock("p", _hoisted_20, [
              _createTextVNode(_toDisplayString(row.loginName) + " ", 1),
              _createVNode(memberEventBox, {
                subscript: false,
                "listen-variable": row
              }, {
                default: _withCtx(() => [
                  _createVNode(AppLink, {
                    to: _unref(useRtfix)('setupUser', { query: { customerId: row.customerId } })
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('编辑')), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _: 2
              }, 1032, ["listen-variable"])
            ]))
      ]),
      customerShopPermission: _withCtx(({ row }) => [
        (row.customerShopAuthStatus && row.customerShopPermission)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((row.customerShopPermission.split('/')), (item, idx) => {
                return (_openBlock(), _createElementBlock("p", { key: idx }, _toDisplayString(item), 1))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_22, "-"))
      ]),
      handler: _withCtx(({ scope }) => [
        _createVNode(AppLink, {
          style: {"min-width":"60px"},
          to: _unref(useRtfix)('setupShop', { query: { customerShopId: scope.row.customerShopId } })
        }, {
          default: _withCtx(() => [
            _createVNode(_component_table_button, {
              title: _unref(t)('配置店铺')
            }, null, 8, ["title"])
          ]),
          _: 2
        }, 1032, ["to"]),
        (scope.row.customerShopAuthStatus)
          ? (_openBlock(), _createBlock(_component_table_button, {
              key: 0,
              title: _unref(t)('取消授权'),
              onClick: ($event: any) => (openCancelAuthorizedVisible(scope.row))
            }, null, 8, ["title", "onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["page-data", "api", "columns", "filterData", "tableConfig"]),
    (shopVisible.value)
      ? (_openBlock(), _createBlock(CreateShop, {
          key: 1,
          modelValue: shopVisible.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((shopVisible).value = $event)),
          shopData: shopData.value,
          onClose: shopClose,
          onOk: createSuccess,
          onListen: shopListen
        }, null, 8, ["modelValue", "shopData"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: subAccountVisible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((subAccountVisible).value = $event)),
      "custom-class": "subAccountVisible"
    }, {
      default: _withCtx(() => [
        (subAccountVisible.value)
          ? (_openBlock(), _createBlock(SignupPanel, {
              key: 0,
              "is-ram": selectCustomerShopId.value,
              onSuccess: signupSuccess,
              onCancel: _cache[4] || (_cache[4] = ($event: any) => (subAccountVisible.value = false))
            }, null, 8, ["is-ram"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(CancelVisible, {
      visible: cancelAuthorizedVisible.value,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((cancelAuthorizedVisible).value = $event)),
      rowItem: rowItem.value,
      onSuccess: refreshTable
    }, null, 8, ["visible", "rowItem"]),
    (!_unref(isD2C)())
      ? (_openBlock(), _createBlock(Guide, {
          key: 2,
          name: "b2b-authorized-store"
        }))
      : _createCommentVNode("", true),
    (_unref(isD2C)())
      ? (_openBlock(), _createBlock(Guide, {
          key: 3,
          name: "d2c-authorized-store"
        }))
      : _createCommentVNode("", true),
    _createVNode(ConfirmOrder, {
      ref: (_value, _refs) => {
        _refs['confirmOrderModal'] = _value
        confirmOrderModal.value = _value
      },
      onSuccess: confirmSuccess
    }, null, 512),
    _createVNode(SyncOrderLimit, {
      ref: (_value, _refs) => {
        _refs['syncOrderLimit'] = _value
        syncOrderLimit.value = _value
      }
    }, null, 512),
    _createVNode(AuthShopChange)
  ]))
}
}

})